import { render, staticRenderFns } from "./lastPenalties.vue?vue&type=template&id=6ae8d62a&"
import script from "./lastPenalties.vue?vue&type=script&lang=js&"
export * from "./lastPenalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports